/**
 * `useIsMobile` — true on viewports below `lg` (1024px), the breakpoint where
 * the school-orders right rail hides and the layout becomes single-column.
 * Drives mobile-only behaviors (e.g. opening a day as a full page rather than
 * expanding it in place). Live: updates on resize via a `matchMedia` listener.
 */

import { useEffect, useState } from 'react'

const MOBILE_QUERY = '(max-width: 1023.98px)'

export function useIsMobile(): boolean {
  const [mobile, setMobile] = useState(
    () =>
      typeof window !== 'undefined' &&
      typeof window.matchMedia === 'function' &&
      window.matchMedia(MOBILE_QUERY).matches,
  )
  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
      return
    }
    const mq = window.matchMedia(MOBILE_QUERY)
    const onChange = (): void => setMobile(mq.matches)
    onChange()
    mq.addEventListener('change', onChange)
    return () => mq.removeEventListener('change', onChange)
  }, [])
  return mobile
}
